<template>
  <!--首页-->
  <div class="home">
    <!--banner-->
    <div class="banner">
      <div class="banner_text">
        <div class="header_logo_app">
          <img src="@/asstes/home/logo_app.png" />
        </div>
        <div class="banner_text_title">数智赋能，“电”定未来</div>
        <div class="banner_text_pgh">
          用创新网联技术驱动新能源产业升级，为实现“双碳”目标贡献力量
        </div>
      </div>
      <div class="banner_img_pc">
        <Banner />
        <!--        <img src="@/asstes/home/home_banner.png">-->
      </div>
      <div class="banner_img_app">
        <img src="@/asstes/home/banner_app.png" />
      </div>
    </div>
    <!--公司简介-->
    <div class="company">
      <div class="company_pic">
        <img src="@/asstes/home/system.png" />
      </div>
      <div class="company_info">
        <div class="company_title" style="width: 100%">
          <span class="company_name">公司简介</span>
          <!--            <span class="company_task">公司使命</span>-->
          <!--          <img src="@/asstes/home/company_title.png">-->
          <!--          <img src="@/asstes/home/company_mission.png">-->
        </div>
        <div class="company_pgh">
          无锡挚达数智科技有限公司（简称无锡挚达）是上海挚达科技发展有限公司的全资子公司。<br />
          <br />
          成立于2017年9月，是全国领先的以充电和车联网为入口的新能源汽车智能网联科技及细分应用场景服务公司。<br />
          <br />
          一直以来新能源科技信息技术及服务产业作为公司在乃至将来的发展过程中发挥非常关键的作用，也将成为其核心竞争的主要来源。
        </div>
        <!--        <img src="@/asstes/home/company_pgh.png">-->
      </div>
    </div>
    <!--解决方案-->
    <div class="solution">
      <div class="solution_info">
        <div class="solution_title">服务与解决方案</div>
        <div class="solution_pgh">聚焦新能源汽车的充电、服务和出行等领域</div>
      </div>
      <div class="solution_tab_pc">
        <div
          class="solution_tab_item"
          v-for="(item, index) in solutionList"
          :key="index"
        >
          <div class="solution_tab_item_img">
            <img :src="item.img" />
          </div>
          <div class="solution_tab_item_title">{{ item.title }}</div>
          <div class="solution_tab_item_pgh">{{ item.pgh }}</div>
        </div>
      </div>

      <div class="solution_tab_app">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in solutionList"
              :key="index"
            >
              <div class="swiper_list"></div>
              <div class="swiper_item">
                <div class="solution_tab_item_img">
                  <img :src="item.img" />
                </div>
                <div class="solution_tab_item_title">{{ item.title }}</div>
                <div class="solution_tab_item_pgh">{{ item.pgh }}</div>
              </div>
              <div class="swiper_list"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--研发实力和技术支持-->
    <div class="brace">
      <div class="brace_info">
        <div class="brace_title">研发实力和技术支撑</div>
        <div class="brace_pgh">软件+硬件+互联网一体化开发交付能力</div>
      </div>
      <div class="brace_tab">
        <div v-for="(item, index) in braceList" :key="index">
          <div class="brace_tab_item" @click="handleChange(item.value)">
            <span :class="{ active: item.value == accountActive }">{{
              item.title
            }}</span>
          </div>
        </div>
      </div>
      <img class="imgFirst" src="@/asstes/home/brace.png" v-show="braceShow" />
      <img
        class="imgSecond"
        src="@/asstes/home/support.png"
        v-show="supportShow"
      />
    </div>
    <!--合作伙伴-->
    <div class="cooperation">
      <div class="cooperation_title">合作伙伴</div>
      <Partner />
    </div>
  </div>
</template>

<script>
import Partner from "./partner";
import Banner from "./banner";
import Swiper from "swiper";
export default {
  components: {
    Banner: (resolve) => {
      require(["./banner"], resolve);
    },
    Partner: (resolve) => {
      require(["./partner"], resolve);
    },
  },
  data() {
    return {
      solutionList: [
        {
          title: "充电运营管理服务系统",
          pgh: "社区充电、目的地充电、共享充电",
          img: require("@/asstes/home/first.png"),
        },
        {
          title: "换电运营车管理系统",
          pgh: "换电重卡、换电资产管理、换电站、电池银行",
          img: require("@/asstes/home/second.png"),
        },
        {
          title: "储能电站运营管理系统",
          pgh: "共享储能、风光新能源用户侧用能、传统火能",
          img: require("@/asstes/home/third.png"),
        },
        {
          title: "城市级绿色出行服务平台",
          pgh: "个人出行、公共交通出行、自主低碳出行、绿色定制出行",
          img: require("@/asstes/home/fourth.png"),
        },
      ],
      braceList: [
        {
          title: "研发实力",
          value: "0",
        },
        {
          title: "技术支持",
          value: "1",
        },
      ],
      accountActive: "0",
      braceShow: true,
      supportShow: false,
    };
  },
  methods: {
    handleChange(val) {
      let that = this;
      that.accountActive = val;
      if (val == 0 || val == "0") {
        that.braceShow = true;
        that.supportShow = false;
      }
      if (val == 1 || val == "1") {
        that.braceShow = false;
        that.supportShow = true;
      }
    },
  },
  mounted() {
    new Swiper(".swiper-container", {
      loop: true,
      // 如果需要分页器
      pagination: "", //.swiper-pagination
      // 如果需要前进后退按钮
      nextButton: "", //.swiper-button-next
      prevButton: "", //.swiper-button- prev
      // 如果需要滚动条
      scrollbar: "", //.swiper-scrollbar
    });
  },
};
</script>

<style lang="less" scoped>
@media only screen and (max-width: 750px) {
  .home {
    width: 100%;

    .banner {
      margin-top: -220px;
      position: relative;

      .banner_text {
        position: absolute;
        top: 457.2px;
        left: 0;
        text-align: center;
        z-index: 99;
        padding: 0 144px;
        box-sizing: border-box;

        .header_logo_app {
          width: 100%;
          padding-bottom: 180px;
          box-sizing: border-box;
        }

        .banner_text_title {
          font-size: 80px;
          font-weight: 600;
          padding-bottom: 60px;
          box-sizing: border-box;
        }

        .banner_text_pgh {
          font-size: 40px;
          font-weight: 600;
          line-height: 60px;
        }
      }

      .banner_img_pc {
        display: none;
      }
      .banner_img_app {
        img {
          width: 100%;
        }
      }
    }

    .company {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 172.8px;

      .company_pic {
        width: 100%;
        padding: 0px 160px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        img {
          width: 100%;
        }
      }

      .company_info {
        text-align: center;
        padding: 0px 160px;
        .company_title {
          text-align: center;
          padding: 160px 0;
          box-sizing: border-box;
          .company_name {
            color: #07cfa2;
            font-weight: 600;
            font-size: 72px;
            padding-right: 80px;
            box-sizing: border-box;
          }
          .company_task {
            font-size: 48px;
            color: #999;
            font-weight: 400;
          }
          /*img:first-child{*/
          /*  width: 32%;*/
          /*  padding-right: 80px;*/
          /*  box-sizing: border-box;*/
          /*}*/
          /*img:last-child{*/
          /*  width: 16%;*/
          /*}*/
        }
        /*img{*/
        /*  width: 72%;*/
        /*}*/
      }
      .company_pgh {
        text-align: left;
        font-size: 50.4px;
        line-height: 90px;
        padding-bottom: 72px;
        box-sizing: border-box;
      }
    }

    .solution {
      text-align: center;

      .solution_info {
        padding-top: 180px;
        box-sizing: border-box;
        .solution_title {
          font-size: 72px;
          font-weight: 600;
          padding-bottom: 64px;
          box-sizing: border-box;
        }
        .solution_pgh {
          font-size: 40px;
          font-weight: 400;
          padding-bottom: 160px;
          box-sizing: border-box;
        }
      }

      .solution_tab_pc {
        display: none;
      }
      .solution_tab_app {
        .swiper-container {
          display: flex;
          width: 100%;
          height: 100%;
          overflow: hidden;
          /*padding: 160px;*/
          box-sizing: border-box;

          .swiper-slide {
            display: flex;

            .swiper_item {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              text-align: center;
              background: #ffffff;
              box-shadow: 0px 1px 20px 8px rgba(178, 178, 178, 0.1);
              border-radius: 47px;
              padding: 0 20px;
              margin: 160px;
              .solution_tab_item_img {
                margin-top: -240px;
                img {
                  width: 100%;
                }
              }
              .solution_tab_item_title {
                width: 100%;
                font-size: 64px;
                font-weight: 600;
                color: #353856;
                padding-bottom: 48px;
                box-sizing: border-box;
              }
              .solution_tab_item_pgh {
                font-size: 48px;
                font-weight: 400;
                color: #353856;
                line-height: 80px;
                padding-bottom: 64px;
                max-width: 640px;
              }
            }
          }
        }
      }
    }

    .brace {
      display: none;
    }

    .cooperation {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 160px 0 160px 0;
      box-sizing: border-box;

      .cooperation_title {
        width: 100%;
        font-weight: 600;
        font-size: 56px;
        text-align: center;
        padding-bottom: 88px;
        box-sizing: border-box;
      }
    }
  }
}
@media only screen and (min-width: 750px) {
  .home {
    width: 100%;
    margin-top: -100px;
    z-index: 80;

    .banner {
      width: 100%;
      position: relative;

      .banner_text {
        position: absolute;
        top: 50%;
        left: 104px;
        margin-top: -80px;
        color: #353856;
        z-index: 99;

        .header_logo_app {
          display: none;
        }
        .banner_text_title {
          font-size: 40px;
          font-weight: 600;
          line-height: 56px;
          padding-bottom: 16px;
          box-sizing: border-box;
        }

        .banner_text_pgh {
          font-size: 18px;
          font-weight: 600;
          line-height: 24px;
        }
      }

      .banner_img_pc {
        /deep/ .el-carousel__button {
          width: 9px;
          height: 9px;
          border-radius: 9px;
        }
        /deep/ .el-carousel__indicator--horizontal {
          padding: 16px 12px;
          box-sizing: border-box;
        }
        /deep/ .el-carousel__indicator.is-active button {
          opacity: 1;
          background-color: #07cfa2;
        }
        /deep/ .el-carousel__indicators--horizontal {
          bottom: 88px;
        }

        img {
          width: 100%;
        }
      }
      .banner_img_app {
        display: none;
      }
    }

    .company {
      padding: 100px 120px 0 120px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .company_pic {
        width: 64%;
        padding-right: 108px;
        box-sizing: border-box;
        img {
          width: 100%;
        }
      }

      .company_info {
        .company_title {
          padding-bottom: 48px;
          box-sizing: border-box;
          text-align: left;

          .company_name {
            color: #07cfa2;
            font-size: 32px;
            font-weight: 600;
            padding-right: 44px;
            box-sizing: border-box;
          }
          .company_task {
            color: #999;
            font-weight: 400;
            font-size: 24px;
          }
        }
        .company_pgh {
          max-width: 460px;
          color: #373a5a;
          font-weight: 400;
          font-size: 16px;
          line-height: 30px;
        }
      }
    }

    .solution {
      width: 100%;
      padding: 96px 120px 0 120px;
      box-sizing: border-box;

      .solution_info {
        width: 100%;
        text-align: center;
        color: #353856;

        .solution_title {
          font-size: 24px;
          font-weight: 600;
          line-height: 32px;
          padding-bottom: 16px;
          box-sizing: border-box;
        }

        .solution_pgh {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          padding-bottom: 64px;
          box-sizing: border-box;
        }
      }

      .solution_tab_pc {
        display: flex;
        justify-content: space-between;

        .solution_tab_item {
          text-align: center;
          max-width: 210px;
          padding: 0 16px;
          box-sizing: border-box;
          height: auto;
          background: #ffffff;
          box-shadow: 0px 1px 16px 7px rgba(178, 178, 178, 0.1);
          border-radius: 18px;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;

          .solution_tab_item_img {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: -56px;
            img {
              width: 100%;
            }
          }

          .solution_tab_item_title {
            max-width: 180px;
            font-size: 16px;
            line-height: 24px;
            font-weight: 600;
            color: #353856;
            padding-bottom: 16px;
            box-sizing: border-box;
          }

          .solution_tab_item_pgh {
            max-width: 160px;
            font-size: 11px;
            font-weight: 400;
            color: #353856;
            line-height: 20px;
            padding-bottom: 24px;
            box-sizing: border-box;
          }
        }
      }

      .solution_tab_app {
        display: none;
      }
    }

    .brace {
      padding: 80px 120px 0 120px;
      box-sizing: border-box;
      text-align: center;

      img {
        padding: 48px 0;
        box-sizing: border-box;
      }
      .imgFirst {
        width: 72%;
      }
      .imgSecond {
        width: 80%;
      }

      .brace_info {
        width: 100%;
        text-align: center;
        color: #353856;

        .brace_title {
          font-size: 24px;
          font-weight: 600;
          color: #353856;
          line-height: 32px;
          padding-bottom: 16px;
          box-sizing: border-box;
        }
        .brace_pgh {
          font-size: 12px;
          font-weight: 400;
          color: #353856;
          line-height: 16px;
          padding-bottom: 24px;
          box-sizing: border-box;
        }
      }

      .brace_tab {
        width: 100%;
        display: flex;
        justify-content: center;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.3);
        font-size: 13px;
        padding-bottom: 64px;
        box-sizing: border-box;

        .brace_tab_item {
          padding: 0 24px;
        }
        .brace_tab_item:hover {
          cursor: pointer;
        }
        .active {
          color: #000000;
          padding-bottom: 16px;
          box-sizing: border-box;
          border-bottom: 2px solid #000;
        }
      }
    }

    .cooperation {
      padding: 80px 120px;
      box-sizing: border-box;
      text-align: center;
      color: #353856;

      .cooperation_title {
        font-size: 24px;
        font-weight: 600;
        color: #353856;
        line-height: 32px;
        padding-bottom: 56px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
